module.exports = __webpack_public_path__ + "static/media/toilets-icon.f0076849.svg";